/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from  'gatsby'
import Icon from 'images/icons/arrow.inline.svg';
import {navlinkWrap, iconWrap, svg } from './navlink_styles.module.scss'


function NavLink({
  children,
  className = '',
  to,
  isExpanded,
  expandable,
  onClick,
  onToggle,
}){
  const isExternalLink = to && to.startsWith('/');

  return (
  <div
    style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
    className={navlinkWrap}
  >
    <Link
      to={`/${to}`}
      onClick={onClick}
      className={className}
      activeClassName='active'
    >

      <span>
        {children} 
      </span>
    </Link>

      {isExternalLink ? (
        <p/>
      ) : expandable ? (
        <span
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onToggle && onToggle(); // eslint-disable-line no-unused-expressions
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter' && onToggle) {
              onToggle(); 
            }
          }}  
          role="button"
          tabIndex={0}
          aria-label="expand"
          className={iconWrap}
        >
          <Icon
            className={svg}
            style={isExpanded ? {width: '20px', height: '20px', transform: 'translateX(5px)', transition: 'all 0.2s ease 0s'} 
                      : {transform: 'rotate(-90deg) translateY(5px)', width: '20px', height: '20px', transition: 'all 0.2s ease 0s'}}
          />
        </span>
      ) : null}
    </div>
  );
};



NavLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  expandable: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  to: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default NavLink;
